import logoRounded from '@assets/images/logo-rounded.webp';
import Collapsible from '@layout/footer/collapsible/Collapsible';
import About from '@layout/footer/footer-menu/About';
import Order from '@layout/footer/footer-menu/Order';
import useIsSmallScreen from '@components/hooks/useIsSmallScreen';
import { Link } from 'react-router-dom';
import { NavigateRoutesEnum } from '@routing/routesEnum';
import SalesNetworkMap from '@layout/footer/SalesNetworkMap';



const Footer = (): JSX.Element => {

	const isSmallScreen = useIsSmallScreen();

	return (
		<div className='app-footer'>

			{!isSmallScreen &&
				<div className='footer-section about-us-section'>
					<h3>Užitečné informace</h3>
					<About />
				</div>}

			{!isSmallScreen &&
				<div className='footer-section about-order-section'>
					<h3>Vše o nákupu</h3>
					<Order />
				</div>}
			
			
			<div className='footer-section map-section'>
				<h3>Prodejní síť</h3>
				<Link to={NavigateRoutesEnum.salesNetwork} className='disable-selection'>
					<SalesNetworkMap />
				</Link>
			</div>

			
			{isSmallScreen &&
				<Collapsible label='VETlímce' className='about-us-section'>
					<About />
				</Collapsible>}

			{isSmallScreen &&
				<Collapsible label='Vše o nákupu' className='about-order-section'>
					<Order />
				</Collapsible>}

			<div className='rounded-logo-wrapper'>
				<img src={logoRounded} alt='footer-logo-rounded' />
			</div>
			
		</div>
	);
}

export default Footer;